<div class="header" [class.degraded]="isDegradedState | async">
  <div class="login-container">
    <div class="logo-user">
      <button class="login-logo" disabled>
        {{ store.user?.userName === " " ? store.user?.emailAddress[0] : store.user?.userName[0] }}
      </button>
    </div>
    <div class="login-informations">
      <div class="login-name">{{ store.user?.userName }}</div>
      <div class="mail">{{ store.user?.emailAddress }}</div>
    </div>
    <div class="offline-logo hide"></div>
    <div class="cross-logo">
      <mat-icon class="icon icon-close on_background" (click)="close()" svgIcon="close"></mat-icon>
    </div>
  </div>
  <div class="user-auth">
    <div class="mat-button hide"></div>
    <div class="mat-button">
      @if (store.isLoggedIn) {
        <div class="login-link" (click)="logout()">
          <span>{{ "logout.title" | translate }}</span>
          <mat-icon svgIcon="logout" class="log-icon on_background"></mat-icon>
        </div>
      } @else {
        <div class="login-link" (click)="login()">
          <span>{{ "login.label" | translate }}</span>
          <mat-icon svgIcon="login" class="log-icon on_background"></mat-icon>
        </div>
      }
    </div>
  </div>
</div>

<!-- App deterioration warning -->
@if (store.deteriorate) {
  <div class="deteriorate-warning">
    {{ "degradation.disclaimer" | translate }}
  </div>
}

<!-- BP2 degraded state -->
@if (isDegradedState | async) {
  <div class="deteriorate-warning">
    {{ "degradation.bp2.disclaimer" | translate }}
  </div>
}

<mat-list>
  <div class="matlist--top" (click)="close()">
    <!-- SRD -->
    @if (srdAvailable) {
      <div class="button-section">
        <mat-list-item class="item-clickable" [routerLink]="['/home/srd/standard']">
          <mat-icon color="primary" svgIcon="srd"></mat-icon>
          {{ "settings.srd" | translate }}
        </mat-list-item>
        <mat-list-item class="item-clickable" [routerLink]="['/home/srd/base']">
          <mat-icon color="primary" svgIcon="srd"></mat-icon>
          {{ "settings.srdBase" | translate }}
        </mat-list-item>
      </div>
    }
    <!-- Print -->
    <mat-list-item class="print-item item-clickable" (click)="print()">
      <mat-icon color="primary" svgIcon="print"></mat-icon>
      {{ "settings.print" | translate }}
    </mat-list-item>
    <!-- Settings -->
    <mat-list-item class="settings-item item-clickable" (click)="openSettings()">
      <mat-icon color="primary" svgIcon="settings"></mat-icon>
      {{ "settings.title" | translate }}
    </mat-list-item>
    <!-- Help -->
    <mat-list-item class="item-clickable" [routerLink]="['/home/help']">
      <mat-icon color="primary" svgIcon="help-circle"></mat-icon>
      {{ "help" | translate }}
    </mat-list-item>
  </div>
</mat-list>
